import * as types from "../redux/types";
import backend from "../api/api";
import { store } from "../redux/store";
import { message } from "antd";

const getConfig = () => {
  const token = store.getState().auth.token;

  const config = {
    headers: {
      Authorization: `Token ${token}`,
    },
  };

  return config;
};

export const createCompany = (formValues) => async (dispatch) => {
  formValues["data"] = "";
  try {
    const response = await backend.post(
      "api/hrm/Company/",
      { ...formValues },
      getConfig()
    );
    if (response.status === 201) {
      dispatch({
        type: types.CREATE_COMPANY,
        payload: { ...response.data },
      });
      message.success("Updated Successfully");
      // history.push("/department");
    }
  } catch (error) {
    alert(error);
  }
};

export const getAllCompany = () => async (dispatch) => {
  try {
    const response = await backend.get("api/hrm/Company/", getConfig());
    if (response.status === 200) {
      dispatch({
        type: types.GET_ALL_COMPANY,
        payload: response.data,
      });
    }
  } catch (error) {
    console.log(error);
  }
};

export const deleteCompany = (id) => async (dispatch) => {
  try {
    const response = await backend.delete(
      `api/hrm/Company/${id}/`,
      getConfig()
    );
    if (response.status === 204) {
      dispatch({ type: types.DELETE_COMPANY, payload: id });
    }
    // history.push("/department");
  } catch (error) {
    alert(error);
  }
};

export const updateCompany = (id, formValues) => async (dispatch) => {
  try {
    const response = await backend.patch(
      `api/hrm/Company/${id}/`,
      formValues,
      getConfig()
    );
    if (response.status === 200) {
      message.success("Updated Successfully");
      dispatch({
        type: types.UPDATE_COMPANY,
        payload: { ...response.data },
      });
    }

    // history.push("/department");
  } catch (error) {
    alert(error.response);
  }
};
